<div class="circles">
  <li></li>
  <li></li>
  <li style="left: -12%"></li>
  <li></li>
</div>
<h1 class="SEO">About Me - Rahil Hastu</h1>
<section class="home-main-section contact-main-section abtme">
  <div class="title aboutmesection">
    <p class="upabout">&lt;about&gt;</p>
    <p class="uph1about">&lt;h1&gt;</p>
    <div class="aboutMe">
      <div class="about">
        <span>A</span>
        <span>b</span>
        <span>o</span>
        <span>u</span>
        <span>t</span>
        <span>&nbsp;</span>
      </div>
      <div class="me">
        <span>M</span>
        <span>E</span>
      </div>
      <p style="margin-bottom: 30px" class="downh1about">&lt;/h1&gt;</p>
      <div class="description">
        <p>
          I am a skilled Software Engineer with over 3 years of experience,
          excelling in both Backend and Frontend roles. My expertise lies in
          Product Development and Software Engineering, where I am dedicated to
          assisting companies in creating highly scalable and resilient
          products. With a focus on building cutting-edge solutions that can
          handle large-scale demands, I ensure robustness and reliability in
          every project. As an avid learner with a naturally curious and
          creative mind, I thrive in Software Engineering and Product
          Development opportunities.<br />

          I approach every challenge with an unstoppable drive to learn and
          succeed. Whether it's bringing a dream to reality or contributing to
          the conceptualization of a vision, I am confident in my ability to
          turn ideas into tangible results.<br />

          If you are seeking a skilled Software Engineer committed to delivering
          exceptional solutions, I am ready to collaborate and bring your
          projects to fruition.
        </p>
      </div>
    </div>
    <div class="timeline"></div>
    <p class="downabout">&lt;/about&gt;</p>
  </div>

  <div class="cuberotate">
    <div class="wrap">
      <div class="cube">
        <div class="front">
          <i class="fab fa-html5"></i>
        </div>
        <div class="back">
          <i class="fab fa-css3"></i>
        </div>
        <div class="top">
          <i class="fab fa-angular"></i>
        </div>
        <div class="bottom">
          <i class="fab fa-js-square"></i>
        </div>
        <div class="left">
          <i class="fab fa-python"></i>
        </div>
        <div class="right">
          <i class="fab fa-node"></i>
        </div>
      </div>
    </div>
  </div>
</section>
